import { useEffect } from "react";

export default function Seo({ title, description }) {
  useEffect(() => {
    if (title) {
      document.title = title;
      const ogTitle = document.querySelector('meta[property="og:title"]');
      if (ogTitle) ogTitle.setAttribute("content", title);
    }
    if (description) {
      const map = [
        ['meta[name="description"]', "content"],
        ['meta[property="og:description"]', "content"],
      ];
      map.forEach(([sel, attr]) => {
        const el = document.querySelector(sel);
        if (el) el.setAttribute(attr, description);
      });
    }
  }, [title, description]);
  return null;
}
